export enum BidvVirtualAccountServiceQueryKeys {
  GET_SERVICE_CODE = 'GET_SERVICE_CODE',
  LIST_VAS = 'LIST_VAS',
  GET_QR = 'GET_QR',
  INQUIRY = 'INQUIRY',
  SYNC_TRANSACTIONS = 'SYNC_TRANSACTIONS',
  EXPORT_VAS = 'EXPORT_VAS',
}